<template>
  <div id="invit">
    <div class="lv4Text" align="right" style="padding:10px 0">
      <router-link to="/help/2_4" class="lv4Text">
        <i class="far fa-question-circle fa-lg" style="margin-right:5px"></i>邀请好友说明
      </router-link>
    </div>
    <div class="box">
      <el-row>
        <el-col :span="3">
          <div class="lv0Text" align="center" style="font-size:16px;">
            <i class="fas fa-gift fa-5x"></i>
            <div class="lv3Text" style="margin-bottom:5px;margin-top:10px">已累计获得</div>
            <div class="lv0Text">{{_.size(list)*200}}积分</div>
          </div>
        </el-col>
        <el-col :span="16">
          <div style="padding-top:30px">
            <el-row style="font-size:14px;" class="lv2Text">
              <el-col :span="3">
                <div style="line-height:40px">邀请链接：</div>
              </el-col>
              <el-col :span="16">
                <div>
                  <el-input v-model="src"></el-input>
                </div>
              </el-col>
              <el-col :span="5" align="right">
                <div>
                  <el-button
                    round
                    v-clipboard:copy="src"
                    v-clipboard:success="onCopy"
                    size="small"
                  >复制链接</el-button>
                </div>
              </el-col>
            </el-row>
          </div>
        </el-col>
        <el-col :span="5" align="center">
          <div style="border:2px solid #ddd;padding:10px;display:inline-block;margin-bottom:10px;">
            <qrcode-vue :value="src" :size="size" level="H"></qrcode-vue>
          </div>
          <div class="lv3Text">扫一扫，用手机邀请好友</div>
        </el-col>
      </el-row>

      <div style="margin-top:30px;" v-if="list">
        <el-table :data="list" style="width: 100%">
          <el-table-column prop="bind_mobile" label="电话"></el-table-column>
          <el-table-column prop="nickname" label="姓名" width="180"></el-table-column>
          <el-table-column label="邀请日期" width="150">
            <template slot-scope="scope">
              <span
                style="margin-left: 10px"
              >{{ dayjs.unix(scope.row.create_date).format('YYYY-MM-DD') }}</span>
            </template>
          </el-table-column>
        </el-table>
      </div>
    </div>
  </div>
</template>
<script>
import QrcodeVue from "qrcode.vue";
export default {
  components: {
    QrcodeVue
  },
  data() {
    return {
      //
      serve: this.$store.state.serve,

      size: 100,
      src: "",
      list: ""
    };
  },
  activated() {
    this.$store.state.user_location = "邀请有礼";
  },
  created() {
    this.initData();
  },
  methods: {
    onCopy: function(e) {
      this.$message({
        message: "链接已复制",
        type: "success"
      });
    },
    initData() {
      this.axios
        .get(this.serve+"/personal/invite_ip", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          this.src = res.data.data;
        });
      this.axios
        .get(this.serve+"/personal/invite_log", {
          params: {
            mobile: this.$cookies.get("user"),
            token: this.$cookies.get("token")
          }
        })
        .then(res => {
          if (res.data.data) {
            this.list = res.data.data;
          }
        });
    }
  }
};
</script>
<style lang="scss">
#invit {
  margin-top: -38px;

  .box {
    background-color: #fff;
    min-height: 550px;

    border: 1px solid #ddd;
    padding: 30px;
  }
}
</style>